import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function CustomizedDialogs() {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
        Comment ça marche ?
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Baobab va te créer un quiz personnalisé sur ta leçon !
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Avant de commencer, assure-toi d'avoir ton cours bien organisé devant toi.
          </Typography>
          <Typography gutterBottom>
           <b>➗ Maths :</b> Lis à haute voix les définitions et théorèmes que tu dois apprendre. 📣
          </Typography>
          <Typography gutterBottom>
           <b>🏰 Histoire/🌎 Géo :</b> Lis à haute voix les parties de ton cours que tu as identifiées comme importantes. 📣
          </Typography>
          <Typography gutterBottom>
            <b>🇬🇧 Anglais ou 🇪🇸 Espagnol :</b> Prends en photo les pages de ton cours. 📸
          </Typography>
          <Typography gutterBottom>
          Une fois terminé, Baobab va te créer un quiz personnalisé (c'est magique !).
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            J'ai compris !
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
